import { CourseActionTypes } from '@/store/actions/types';
import { Vue } from 'vue-property-decorator';
import { CourseItemData, CourseTheme } from '@/views/media/course/components/course-item';
import moment from 'moment';
import { CikeUtils } from '@/utils';
import { COURSE_TYPES } from '@/maps/enum/course';


const CourseActions = {
  async [CourseActionTypes.GET_SCREEN_SINGLE](context: any, payload: { type: COURSE_TYPES, weekUnit: 'time' | 'day', params?: { type?: Array<COURSE_TYPES>; start_time?: string; end_date?: string; end_time?: string; week?: Array<number>; curriculum_id?: Array<number>; store_id?: Array<number>; begin_date?: string; } }): Promise<{ colorMap?: Array<{ color: string; count: number; }>, courseMap: Map<string, Map<string, CourseItemData>> | Map<string, Array<Map<string, CourseItemData>>>, storeMap: Array<string>, courseThemeMap?: Map<string, { name: string; id: number; theme: CourseTheme; nodeMap: Array<string> }>; }> {
    /**
     * 整个数据结构 - Map<string<表格的周标题>,array<课程卡片>> - 课程卡片又包含主题,课程列表
     **/
    let tableHeader: Map<number, string> = new Map<number, string>();
    let date = moment(payload.params?.begin_date);

    /**时间单位*/
    function weekTime() {
      for (let i = 0; i < 7; i++) {
        tableHeader.set(date.weekday(), `周${CikeUtils.weekNumToZH_CN(date.weekday())} | ${date.format('MM.DD')}`);
        date.add(1, 'd').weekday();
      }
    }

    /**week英文缩写*/
    function weekDay() {
      for (let i = 0; i < 7; i++) {
        tableHeader.set(date.weekday(), `周${CikeUtils.weekNumToZH_CN(date.weekday())} | ${CikeUtils.weekNumToUA_EN(date.weekday())}`);
        date.add(1, 'd').weekday();
      }
    }

    /**名称策略*/
    switch (payload.weekUnit) {
      case 'day':
        weekDay();
        break;
      case 'time':
        weekTime();
        break;
      default:
    }

    //门店列表
    let storeMap: Array<string> = [];

    //节点列表
    let nodeMap: Array<string> = [];

    //课程颜色地图
    let colorMap: Array<{ color: string; count: number; id: number; alias: string; }> = [];

    //TODO 现阶段只生成一种课表,如果需要同时检索学期课和单词课,需要修改该逻辑
    if (payload.params?.type?.some(type => type == COURSE_TYPES.TYPE_SEMESTER_COURSE)) {
      delete payload.params?.end_time;
    }
    //计算结束时间
    const END_DATE = payload.params?.type?.some(type => type == COURSE_TYPES.TYPE_SEMESTER_COURSE) ? {} : { end_date: moment(payload.params?.begin_date).add(6, 'day').format('YYYY-MM-DD') };

    /**主题组装*/
    function courseTheme(color: string): CourseTheme {
      return {
        content: CikeUtils.colorRGBA(color, .4),
        header: CikeUtils.colorRGBA(color, .8),
        name: CikeUtils.colorRGB2Hex(color, .4)
      };
    }

    /**集训-设置颜色地图指引*/
    function updateColor(colorMap: Array<{ color: string; count: number; id: number; alias: string; }>, color: string, id: number, alias: string) {
      let index_color = colorMap.findIndex(color_map => color_map.color == color);
      if (index_color != -1 && colorMap[index_color].id == id) {
        colorMap[index_color].count = colorMap[index_color].count + 1;
      }
      let index_id = colorMap.findIndex(color_map => color_map.id == id || color_map.alias == alias);
      if (index_id == -1 && index_color == -1) {
        colorMap.push({ color: color, count: 1, id: id, alias: alias });
      }
    }

    /**课程别名处理*/
    function courseAlias(alias: string) {
      return alias;
    }

    /**门店全名处理*/
    function storeName(course: any) {
      return `${course?.store.name}`;
    }

    /**组装course对象*/
    function packageCourse(data: any): CourseItemData {
      let course: CourseItemData = {
        key: moment().valueOf(),
        id: data.id,
        merge: 1,
        datetime: `${data.time} - ${data.end_time}`,
        //主题设置
        theme: courseTheme(data?.course?.curriculum?.color)!,
        course: [courseInit({ ...data })],
      };
      return course;
    }

    /**课程信息提取*/
    function courseInit(data: any): any {
      return {
        // @ts-ignore
        teacher: data?.course?.employee?.name,
        id: data?.course?.curriculum?.id || -1,
        name: courseAlias(data?.course?.alias),
        store: storeName(data),
        day: 1,
        theme: courseTheme(data?.course?.curriculum?.color),
        show: true,
      };
    }

    /**时间对象排序*/
    function soltList(ary: Array<string>) {
      //时间筛选用的排序
      ary.sort((a: string, b: string) => {
        let nodeA = a.split('-')[0].split(':');
        let nodeB = b.split('-')[0].split(':');
        let momentA = moment().hours(+nodeA[0]).minutes(+nodeA[1]);
        let monentB = moment().hours(+nodeB[0]).minutes(+nodeB[1]);
        //分钟判断
        if (moment(momentA).isBefore(monentB, 'minute')) {  //按时间进修排序
          return -1;
        } else {
          return 1;
        }
      });
    }
    try {

      // let res = await Vue.prototype.$axios.course.getScreenSingle(Object.assign(payload.params, END_DATE));
      // let data: Array<any> = res.list;

      // 未上架
      const ddd = [
        {
          "id": 106502,
          "time": "20:05",
          "week": 5,
          "course_id": 18834,
          "hour": "1",
          "store_id": 19,
          "date": "2021-10-08",
          "classroom_id": 26,
          "store_name": "淘金A",
          "store": {
            "id": 19,
            "name": "淘金店",
            "simplename": "淘金"
          },
          "classroom": {
            "id": 26,
            "capacity": 10,
            "name": "A",
            "display_name": "教室A"
          },
          "end_time": "21:05",
          "end_time_complete": false,
          "course": {
            "id": 18834,
            "time": "20:05",
            "times": 4,
            "hour": "1",
            "main_teacher": 60,
            "curriculum_id": 194,
            "capacity": 10,
            "alias": "天鹅肩臂(短期)",
            "type": 5,
            "employee": {
              "id": 60,
              "name": "杨芳",
              "img": "https://file.balletme.com/images/teacher/yf.jpg",
              "is_show": 1,
              "status": 1,
              "tips": null,
              "number": 59,
              "_id": "5da4518c6616b600062da2dc",
              "user_id": 0,
              "index": 75,
              "created_at": "2019-12-11 15:54:05",
              "updated_at": "2020-05-04 20:12:55",
              "img_resize": "https://file.balletme.com/images/teacher/yf.jpg?x-oss-process=image/resize,p_30"
            },
            "curriculum": {
              "id": 194,
              "name": "天鹅肩臂(短期)",
              "color": "#fdf7e3",
              "classification_id": 3,
              "course_type": 2,
              "difficulty": 0,
              "hour": "1"
            },
            "end_time": "21:05"
          },
          "datetime": "20:05 - 21:05"
        },


        {
          "id": 106520,
          "time": "20:05",
          "week": 2,
          "course_id": 18840,
          "hour": "1",
          "store_id": 22,
          "date": "2021-10-05",
          "classroom_id": 32,
          "store_name": "中盈A",
          "store": {
            "id": 22,
            "name": "体育西路店",
            "simplename": "中盈"
          },
          "classroom": {
            "id": 32,
            "capacity": 8,
            "name": "A",
            "display_name": "教室A"
          },
          "end_time": "21:05",
          "end_time_complete": false,
          "course": {
            "id": 18840,
            "time": "20:05",
            "times": 4,
            "hour": "1",
            "main_teacher": 52,
            "curriculum_id": 120,
            "capacity": 8,
            "alias": "足尖零基础(短期)",
            "type": 5,
            "employee": {
              "id": 52,
              "name": "施艳仪",
              "img": "https://file.balletme.com/images/施艳仪.jpg",
              "is_show": 1,
              "status": 1,
              "tips": null,
              "number": 35,
              "_id": "5c9782a22503b18a67b2982e",
              "user_id": 0,
              "index": 81,
              "created_at": "2019-12-11 15:54:05",
              "updated_at": "2021-07-07 16:16:03",
              "img_resize": "https://file.balletme.com/images/施艳仪.jpg?x-oss-process=image/resize,p_30"
            },
            "curriculum": {
              "id": 120,
              "name": "足尖零基础(短期)",
              "color": "#f4d9e7",
              "classification_id": 3,
              "course_type": 3,
              "difficulty": 3,
              "hour": "1"
            },
            "end_time": "21:05"
          },
          "datetime": "20:05 - 21:05"
        }
      ]
      // 多重时间筛选
      let data: Array<any> = [];
      for (let begin_date of ['2021-10-04', '2021-09-06']) {
        let res = await Vue.prototype.$axios.course.getScreenSingle({ ...payload.params, END_DATE, begin_date })
        //课程中出现门店列表获取
        res.select_stores.map((stores: any) => {
          storeMap.push(stores?.name);
        });
        data = data.concat(res.list)
      }
      data = data.concat(ddd).filter((filter) => [18698, 18668, 18659, 18650, 18629, 18617, 18587, 18533, 18508, 18475, 18460, 18413, 18364, 18065, 17879, 17861, 17848, 17840, 18840, 18839, 18838, 18837, 18834].includes(filter.course_id))
      let ids = [18698, 18668, 18659, 18650, 18629, 18617, 18587, 18533, 18508, 18475, 18460, 18413, 18364, 18065, 17879, 17861, 17848, 17840, 18840, 18839, 18838, 18837, 18834];
      data.forEach(cou => {
        const index = ids.findIndex(id => id == cou.course_id)
        ids.splice(index,1)
      })
      console.log(ids)
      /**week头*/
      let headerMap = Array.from(tableHeader).map(value => {
        return value[1];
      });

      switch (payload?.type) {
        //TODO 集训课程表数据打包
        case COURSE_TYPES.TYPE_TRAINING_FIVE:
        case COURSE_TYPES.TYPE_TRAINING:
          let trainingMap: Map<string, Map<string, CourseItemData | any>> = new Map<string, Map<string, CourseItemData>>();
          for (let traing of data) {
            let TRAING_COURSE_ID = traing?.course?.curriculum?.id;
            let TRAING_COURSE_ALIAS = traing?.course?.alias;
            let TRAING_COURSE_NAME = traing?.course?.curriculum?.name;
            let TRAING_COURSE_WEEK = traing?.week;
            let TRAING_COURSE_COLOR = traing?.course?.curriculum?.color || '#960208';
            let datetime = `${traing.time} - ${traing.end_time}`;
            if (trainingMap.has(datetime)) {  //存在该时间节点,有则遍历该节点
              trainingMap.get(datetime)!
                .forEach((course, course_key, course_map) => {
                  let iningMap: Map<string, CourseItemData> = trainingMap.get(datetime)!;
                  let courseList = course?.course || [];
                  if (!course) {  //空节点跳过
                    if (course_key === tableHeader.get(TRAING_COURSE_WEEK)!) { //week节点位置相同
                      let isCourse = true;
                      trainingMap.get(datetime)!.forEach(filter => {  //校验map中是否存在该课程,存在则不新建
                        if (filter?.course[0].id == TRAING_COURSE_ID && courseAlias(TRAING_COURSE_ALIAS || '') == filter?.course[0].name) {
                          isCourse = false;
                        }
                      });
                      if (isCourse) {
                        iningMap.set(tableHeader.get(TRAING_COURSE_WEEK)!, Object.assign(packageCourse(traing), {
                          day_end: 1
                        }));
                        trainingMap.set(datetime, iningMap);
                        //课程颜色地图指引更新
                        updateColor(colorMap, TRAING_COURSE_COLOR, TRAING_COURSE_ID, TRAING_COURSE_ALIAS);
                      }
                    }
                    return;
                  }
                  //判断是否存在该课程,存在则找到位置-每个week只能有一个,所以默认0起步
                  if (courseList.some((cour: any) => cour.id === TRAING_COURSE_ID && courseAlias(TRAING_COURSE_ALIAS || '') == cour.name)) {
                    updateColor(colorMap, TRAING_COURSE_COLOR, TRAING_COURSE_ID, TRAING_COURSE_ALIAS);
                    if (course_key == tableHeader.get(0)) { //周日不叠加
                      return;
                    }

                    let day = +courseList![0].day! + 1;
                    courseList![0].day = day;
                    iningMap.set(course_key!, Object.assign(packageCourse(traing), {
                      course: courseList,
                      day_end: 1  //用于判断是否为集训课
                    }));
                    trainingMap.set(datetime, iningMap);
                  }
                });
            } else {
              let map = new Map<string, CourseItemData | any>();
              tableHeader.forEach(key => {  //初始化列表,一周内所有课程都设置出来
                map.set(key, null);
              });
              trainingMap.set(datetime, map);
              let item = trainingMap.get(datetime)!.set(tableHeader.get(TRAING_COURSE_WEEK)!, Object.assign(packageCourse(traing), { day_end: 1 }));
              updateColor(colorMap, TRAING_COURSE_COLOR, TRAING_COURSE_ID, TRAING_COURSE_ALIAS);
              trainingMap.set(datetime, item);
            }
          }

          for (let node of trainingMap.keys()) {
            nodeMap.push(node);
          }
          soltList(nodeMap);
          //数据结构输出
          return Promise.resolve({
            courseMap: trainingMap,
            storeMap: storeMap,
            nodeMap: nodeMap,
            headerMap: headerMap,
            colorMap: colorMap!
          });
        //TODO 普通课程表数据打包
        default:
          let map: Map<string, Map<string, CourseItemData
          >> = new Map<string, Map<string, CourseItemData>>();
          tableHeader.forEach(key => {  //初始化列表
            map.set(key, new Map<string, CourseItemData>());
          });
          for (let d of data) {
            console.log(data);
            let value: any = d;
            let datetime = `${value.course.time} - ${value.end_time}`;
            value.datetime = datetime;
            if (!nodeMap.includes(datetime)) {  //判断该key中的列表是否存在该时间段,不存在直接push
              nodeMap.push(datetime);
            }
            let loadMap = map.get(tableHeader.get(value.week)!) ?? new Map<string, CourseItemData>();
            if (loadMap!.has(datetime)) {  //判断该时段上是否存在课程
              let md: CourseItemData = loadMap!.get(datetime)!;
              //这里在原数组上添加课程,但是会导致出现undefind的课程
              md.course!.push({
                id: value.course?.curriculum?.id || -1,
                name: courseAlias(value.course?.alias),
                store: storeName(value),
                theme: courseTheme(value?.course?.curriculum?.color),
                show: true
              });
              loadMap!.set(datetime, md);
              map.set(tableHeader.get(value.week)!, loadMap!); //moment的week周一为0
            } else {
              loadMap!.set(datetime, packageCourse(value));
              map.set(tableHeader.get(value.week)!, loadMap);
            }
          }

          Array.from(map.keys()).forEach(key => {
            if (map.get(key)!) {
              //map转array
              let ary: Array<any> = Array.from(map.get(key)!);
              ary.sort((a: Array<any>, b: Array<any>) => {
                let timeA = a[0].split('-')[0].split(':');
                let timeB = b[0].split('-')[0].split(':');
                let momentA = moment().hours(timeA[0]).minutes(timeA[1]);
                let monentB = moment().hours(timeB[0]).minutes(timeB[1]);
                //分钟判断
                if (moment(momentA).isBefore(monentB, 'minute')) {  //按时间进修排序
                  return -1;
                } else {
                  return 1;
                }
              });
              //array转mapend_date
              map.set(key, new Map<string, CourseItemData>(ary.map(i => [i[0], i[1]])));
            }
          });
          soltList(nodeMap);
          //门店数据获取~
          return Promise.resolve({
            courseMap: map, storeMap: storeMap, nodeMap: nodeMap, headerMap: headerMap
          });
      }
    } catch (error) {

    }




  }
};
export default CourseActions;
